 import React, { useContext, useEffect, useState } from "react";
//import Select from 'react-select'
import Service from "../../services";
import { AxiosError } from "axios";
import { Input } from "reactstrap";
import { catchError } from "../../utils/Utils";
import CreatableSelect from 'react-select/creatable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose, faFileLines } from "@fortawesome/free-solid-svg-icons";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import { TriggerContext } from "../../Context/TriggerContext";
interface addLabelProps{
  clientId?: string|undefined;
  getLeadData?: any;
  labels?:any;
  trackerName?:string;
}

const AddLabel = (props:addLabelProps) => { 
    const [selectedOption, setSelectedOption] = useState<any>(null);// this will reset the selected value
        const [selectedOptionsList, setSelectedOptionsList] = useState<any>(props.labels);
        const [selectVisible, setSelectVisible] = useState<boolean>(false);
        const [initialOptions, setInitialOptions] =useState([]);
        const service = new Service() ;
        const clientContext =  useContext(TriggerContext);
        
        
        useEffect(()=>{getAddLabels()}, []);
        useEffect(()=>{if(props.labels){     
          setSelectedOptionsList(props.labels.map((l:any)=>{l.value=l.clientLabelMappingId; return l;}));
        }
        }, [props.labels]);
        const getAddLabels = () => {
          const payload = {
             screen: "ProspectDetails",
             sections: "getLabelMasterList",
             isJsonReturnObject: false,
           
             data:{
              labelMasterId: '',
              label:"label",
              clientId:props.clientId
              }
           
          };
          service
            .getLeadsData(payload)
            .then((res: any) => {
              setInitialOptions(res.data?.map((l:any)=>{
                l.value = l.labelMasterId;
                return l;
              }));             
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
            
            });
        };
        const deleteLabel = (clientLabelMappingId:any) => {
          const payload = {     
            sections: "ClientLabelMapping",
            data:{
            "clientLabelMappingId": clientLabelMappingId
            }
          
         };
         service
           .deleteLabel(payload)
           .then((res: any) => {
             getAddLabels();
             props.getLeadData();
             
           })
           .catch((error: AxiosError) => {
            catchError(error, true);
          
          });
        }


        const handleChange = (selectedOption: any) => {          
          setSelectedOption(selectedOption);
        };
      
        const handleAddToSelectedList = () => {

          if (selectedOption && !selectedOptionsList.includes(selectedOption)) {
            setSelectedOptionsList([...selectedOptionsList, selectedOption]);
          }
          saveLabels(selectedOption);
          setSelectVisible(false)        
        };
      
        const handleDelete = (value: any) => {             
          deleteLabel(value);         
        };

         
 const onCreateOption = (e:any)=>{
  
  const payload = {
    screen: "ProspectDetails",
    sections: "ClientLabelMapping",
    data:{
    labelMasterId: '',
    label:e.label,
    clientId:props.clientId
    }
  
 };
 service
   .getLeadsData(payload)
   .then((res: any) => {
      getAddLabels()
      props.getLeadData();
   })
   .catch((error: AxiosError) => {
     catchError(error, true);
   
   });
 }
 const saveLabels = (e:any)=>{
  
  const payload = {
    screen: "ProspectDetails",
    sections: "ClientLabelMapping",
    data:{
    labelMasterId: e?.value,
    label:e?.label,
    clientId:props.clientId
    }
  
 };
 service
   .leadInfo(payload)
   .then((res: any) => {
      getAddLabels();
      props.getLeadData()
   })
   .catch((error: AxiosError) => {
     catchError(error, true);
   
   });
 }

 const addNewOption = (label:any)=>{
    setSelectedOption({label});
 }
 const showAddLabel = () => {
  setSelectVisible(!selectVisible)
  setSelectedOption(null); 
 }


  return (
    <div className="add-label-wrapper">
      <div className="header-wrap">
      <h4> LABELS</h4>
        {RoleAuthorization(Pages.customerDetailsPage,actionAuthorization.accessAddLabel)&& !clientContext?.readOnlyMode  && 
        props?.trackerName === "LORATrackers" &&
        <button onClick={() => showAddLabel()}>
         
          Add Label
        </button>}
      </div>
        {selectVisible && (
          <div className="selector-wrap">
            <CreatableSelect
              isClearable
              createOptionPosition = "first"
              getOptionValue={option => `${option}`}
              value={selectedOption}
              onChange={handleChange}
              options={initialOptions}
              isSearchable={true}
              placeholder="Select"
              onCreateOption={addNewOption}
              className="CreatableSelect"
              classNamePrefix="CreatableSelect"
             
            />       
 
 
            <button disabled={!selectedOption?true:false} className="addBtn" onClick={handleAddToSelectedList}><FontAwesomeIcon icon={faCheck} /></button>
            <button className="closeBtn" onClick={() => setSelectVisible(false)}><FontAwesomeIcon icon={faClose} /></button>
          </div>
        )}
        <ul className="labels-all">
          {selectedOptionsList.map((option:any) => (
            <li  key={option.value}>
              <span style={{flex:"1"}}className="add-label">{option.label}</span>
              {RoleAuthorization(Pages.customerDetailsPage,actionAuthorization.deleteLabel) &&
              <button className="deleteBtn" onClick={() => handleDelete(option.value)}><FontAwesomeIcon icon={faClose} /></button>}
            </li>
          ))}
        </ul>
    </div>
  );
};

export default AddLabel;
